import React from "react";
import {
  SidebarContent,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTheme } from '@/contexts/ThemeContext';
import { SETTINGS_TABS, type SettingsTab } from "@/config/settingsTabs";

export function AppSettingsSidebar({ active, onTabChange, tabs }: { active: string, onTabChange?: (key: string) => void, tabs?: SettingsTab[] }) {
  const { isDark } = useTheme();
  const tabsToShow = tabs ?? SETTINGS_TABS;

  return (
    <div className="h-full min-h-screen flex flex-col bg-card border-r border-border">
      <SidebarContent className="flex-1 h-full">
        {tabsToShow.map((item, index) => {
          // Check if this is a group
          if (item.type === "group" && item.options) {
            return (
              <SidebarGroup key={item.label || index}>
                <SidebarGroupLabel className="text-foreground">{item.label}</SidebarGroupLabel>
                <SidebarGroupContent>
                  <SidebarMenu>
                    {item.options.map((option) => (
                      <SidebarMenuItem key={option.key}>
                        <SidebarMenuButton
                          asChild
                          isActive={active === option.key}
                        >
                          <button
                            onClick={() => onTabChange && option.key && onTabChange(option.key)}
                            className="settings-sidebar-item flex items-center gap-3 w-full text-left py-2 px-3 rounded-md transition-colors"
                            data-active={active === option.key}
                          >
                            {option.icon && (
                              <FontAwesomeIcon
                                icon={option.icon}
                                className={`w-4 h-4 ${active === option.key ? 'text-primary' : 'text-muted-foreground'}`}
                              />
                            )}
                            <span className={active === option.key ? 'text-primary font-medium' : 'text-muted-foreground'}>
                              {option.label}
                            </span>
                          </button>
                        </SidebarMenuButton>
                      </SidebarMenuItem>
                    ))}
                  </SidebarMenu>
                </SidebarGroupContent>
              </SidebarGroup>
            );
          }
          
          // Fallback for non-grouped items (backwards compatibility)
          return (
            <SidebarGroup key={item.key || index}>
              <SidebarGroupContent>
                <SidebarMenu>
                  <SidebarMenuItem key={item.key}>
                    <SidebarMenuButton
                      asChild
                      isActive={active === item.key}
                    >
                      <button
                        onClick={() => onTabChange && item.key && onTabChange(item.key)}
                        className="settings-sidebar-item flex items-center gap-3 w-full text-left py-2 px-3 rounded-md transition-colors"
                        data-active={active === item.key}
                      >
                        {item.icon && (
                          <FontAwesomeIcon
                            icon={item.icon}
                            className={`w-4 h-4 ${active === item.key ? 'text-primary' : 'text-muted-foreground'}`}
                          />
                        )}
                        <span className={active === item.key ? 'text-primary font-medium' : 'text-muted-foreground'}>
                          {item.label}
                        </span>
                      </button>
                    </SidebarMenuButton>
                  </SidebarMenuItem>
                </SidebarMenu>
              </SidebarGroupContent>
            </SidebarGroup>
          );
        })}
      </SidebarContent>
    </div>
  );
}
